// initial state
const state = {
  language: 'th'
}

// getters
const getters = {}

// actions
const actions = {
  switchLang({commit}, lang) {
    commit('setLang', lang);
  },
  yearFormat({state}, year) {
    switch (state.language) {
      case 'th':
        return year

      default:
        return parseInt(year) - 543
    }
  }
}


// mutations
const mutations = {
  setLang(state, data) {
    state.language = data;
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
